import { render } from "./CustomerTypeList.vue?vue&type=template&id=6d746382&scoped=true"
import script from "./CustomerTypeList.vue?vue&type=script&lang=js"
export * from "./CustomerTypeList.vue?vue&type=script&lang=js"

import "./CustomerTypeList.vue?vue&type=style&index=0&id=6d746382&scoped=true&lang=css"

import exportComponent from "C:\\projects\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Company\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d746382"]])

export default __exports__